export const COOKIES_KEYS = {
	LanguageAdded: 'LanguageAdded',
};

export const QUERY_PARAMETERS_KEYS = {
	serviceId: 'serviceId',
	branchId: 'branchId',
	serviceProvider: 'serviceProvider',
	selectedServices: 'selectedServices',
	addMoreService: 'addMoreService',
	timeAndDate: 'timeAndDate',
	serviceQuestionnaire: 'serviceQuestionnaire',
	paymentMethod: 'paymentMethod',
};
